var R;(function(O){O[O.OFF=0]="OFF",O[O.ERROR=1]="ERROR",O[O.WARN=2]="WARN",O[O.INFO=3]="INFO",O[O.LOG=4]="LOG",O[O.DEBUG=5]="DEBUG"})(R||(R={}));export{R as a};
